import { gql } from '@apollo/client';

export default gql`
  mutation updateSquadShifts($input: UpdateSquadShiftInput!) {
    updateSquadShifts(input: $input) {
      count
    }
  }
`;
